import { Paper, Typography, Button, TableContainer, CircularProgress } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import moment from "moment";
import { useEffect,MouseEvent } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import { dailyInvoiceReportPdf, dailyInvoiceReportSearch } from "../services";

const DailyInvoiceReport = () => {
      const { control, reset, getValues } = useForm();
      const {
        mutate: getDailyInvoiceReport,
        data: invoiceData,
        isLoading: reportLoading,
        reset:resetMutation
      } = useMutation(dailyInvoiceReportSearch)
    
      const { mutate: getDailyRevenueReportPdf, isLoading: pdfLoading } =
        useRepotFile({
          apiFunction: dailyInvoiceReportPdf,
        });
    //   const { mutate: getDailyRevenueReportExcel, isLoading: excelLoading } =
    //     useRepotFile({
    //       apiFunction: async()=>new Promise(),
    //       fileType: "xls",
    //       responseFileKey: "file",
    //     });
    
      const onChange = () => {
        const data = getValues();
        if (data?.fromDate && data?.toDate) {
          getDailyInvoiceReport(data as { fromDate: string; toDate: string });
        }else{
          resetMutation()
        }
      };
    
      const clearForm = () => {
        reset({
          fromDate: "",
          toDate: "",
        });
        resetMutation()
      };
    
      const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
        const fileType = e.currentTarget.dataset.filetype;
        const allData = getValues();
        if (fileType === "pdf") {
          getDailyRevenueReportPdf({
            fromDate: allData.fromDate,
            toDate: allData.toDate,
          });
        } 
        // else {
        //   getDailyRevenueReportExcel({
        //     fromDate: allData.fromDate,
        //     toDate: allData.toDate,
        //   });
        // }
      };
      useEffect(() => {
        getDailyInvoiceReport({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        });
        reset({
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        });
      }, []);
   return (
        <div className="px-3 py-4 flex flex-col gap-3">
          <Paper>
            <div className="p-4 border-b">
              <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
                Daily Invoice Report
              </Typography>
            </div>
            <form
              // onSubmit={handleSubmit(onSubmit)}
              className="grid grid-cols-2 gap-3 p-4"
            >
              <CustomFormField
                control={control}
                element="datepicker"
                name="fromDate"
                fieldProps={{ label: "From Date" }}
                rules={{ required: "From Date is required", onChange }}
              />
              <CustomFormField
                control={control}
                element="datepicker"
                name="toDate"
                fieldProps={{ label: "To Date" }}
                rules={{ required: "To Date is required", onChange }}
              />
              <div className="col-span-full flex justify-end items-center gap-3">
                {/* <Button
                  type="submit"
                  disabled={reportLoading}
                  endIcon={reportLoading && <CircularProgress size={18} />}
                >
                  search
                </Button> */}
                <Button color="error" onClick={clearForm}>
                  clear
                </Button>
              </div>
            </form>
          </Paper>
    
          <TableContainer component={Paper}>
            <div className="flex justify-end gap-3 py-2 px-4 border-b">
              <Button
                disabled={pdfLoading || !Boolean(invoiceData?.response?.length)}
                endIcon={pdfLoading && <CircularProgress size={18} />}
                data-filetype="pdf"
                onClick={getFiles}
              >
                pdf
              </Button>
              {/* <Button
                disabled={excelLoading || !Boolean(invoiceData?.response?.length)}
                endIcon={excelLoading && <CircularProgress size={18} />}
                data-filetype="excel"
                onClick={getFiles}
              >
                excel
              </Button> */}
            </div>
            <TableComponent
              loading={reportLoading}
              data={invoiceData?.response || []}
              tableProps={heading}
            />
          </TableContainer>
        </div>
   )
}

export default DailyInvoiceReport;

const heading = [
  { heading: "DATE", key: "date" },  
  { heading: "Cost", key: "totalAmt" },  
  { heading: "Discount", key: "totalDiscount" },  
  { heading: "Patient Share", key: "patShare" },  
  { heading: "Total Ins Amount", key: "InsuranceAmt" },  
]